<template>
<div class="md-layout">
  <div class="md-layout-item">
    <md-card id="data-table">
      <md-card-header id="header" class="md-card-header-icon md-card-header-green">
        <div class="card-icon">
          <md-icon>list_alt</md-icon>
        </div>

        <h4 class="title inlineTitle">
          {{ title }}
        </h4>

        <!-- Print -->
        <md-button
          class="margin-left margin-top md-sm md-facebook"
          @click='generateFile("print")'
          :disabled='loadingGeneration.print || dialogsGeneration'
          style='float: right;'
        >
          <template v-if='!loadingGeneration.print'>
            <md-icon style='font-size: 24px !important;'> print </md-icon>
            <md-tooltip md-direction="bottom">
              {{$t('table.printOut')}}
            </md-tooltip>
          </template>

          <template v-else>
            <v-progress-circular
              size='24'
              width='2'
              style='transition: 0.1s; height: 33px;'
              color='#fff'
              indeterminate
            />
          </template>
        </md-button>

        <VueJsonToCsv
          id="csv-component"
          :json-data='csvData'
          :csv-title="csvName"
          :labels='formatedCVSLabels'
          style='opacity: 0; pointer-events: none;'
        />

        <!-- CSV -->
        <md-button
          class="margin-left margin-top md-sm md-facebook"
          @click='generateFile("csv")'
          :disabled='loadingGeneration.csv || dialogsGeneration'
          style='float: right;'
        >
          <template v-if='!loadingGeneration.csv'>
            <md-icon style='font-size: 24px !important;'> table_view </md-icon>
            <md-tooltip md-direction="bottom">
              {{$t('table.generateSpreadsheet')}}
            </md-tooltip>
          </template>

          <template v-else>
            <v-progress-circular
              size='24'
              width='2'
              style='transition: 0.1s; height: 33px;'
              color='#fff'
              indeterminate
            />
          </template>
        </md-button>

        <!-- PDF -->
        <md-button
          class="margin-top md-sm md-facebook"
          @click='generateFile("pdf")'
          :disabled='loadingGeneration.pdf || dialogsGeneration'
          style='float: right; margin-right: 0px;'
        >
          <template v-if='!loadingGeneration.pdf'>
            <md-icon style='font-size: 24px !important;'> picture_as_pdf </md-icon>
            <md-tooltip md-direction="bottom">
              {{$t('table.exportPdf')}}
            </md-tooltip>
          </template>

          <template v-else>
            <v-progress-circular
              size='24'
              width='2'
              style='transition: 0.1s; height: 33px;'
              color='#fff'
              indeterminate
            />
          </template>
        </md-button>
        <!-- XLS -->
        <md-button
            v-if="isSefMg"
            class="margin-top md-sm md-facebook"
            @click='generateFile("xlsx")'
            :disabled='loadingGeneration.xlsx || dialogsGeneration'
            style='float: right; margin-right: 0px;'
        >
          <template v-if='!loadingGeneration.xlsx'>
            <XLSXIcon class="icon-size"/>
            <md-tooltip md-direction="bottom">
              {{$t('dataTable.exportXLSX')}}
            </md-tooltip>
          </template>
          <template v-else>
            <v-progress-circular
                size='24'
                width='2'
                style='transition: 0.1s; height: 33px;'
                color='#fff'
                indeterminate
            />
          </template>
        </md-button>
        <!-- XLS -->
        <md-button
            v-if="isSefMg"
            class="margin-top md-sm md-facebook"
            @click='generateFile("xls")'
            :disabled='loadingGeneration.xls || dialogsGeneration'
            style='float: right; margin-right: 0px;'

        >
          <template v-if='!loadingGeneration.xls'>
            <XLSIcon class="icon-size"/>
            <md-tooltip md-direction="bottom">
              {{$t('dataTable.exportXLS')}}
            </md-tooltip>
          </template>
          <template v-else>
            <v-progress-circular
                size='24'
                width='2'
                style='transition: 0.1s; height: 33px;'
                color='#fff'
                indeterminate
            />
          </template>
        </md-button>

      </md-card-header>

      <md-card-content>
        <!-- class="md-primary" -->
        <md-progress-bar
          :class='{ invisible: !delayedLoading }'
          md-mode='query'
          style='margin-bottom: 0px;'
        />
        <md-table
          class="paginated-table table-striped table-hover"
          id='chatList'
          v-model='data'
          :md-sort='currentSort'
          @update:mdSort='$emit("update:currentSort", $event)'
          :md-sort-order='currentSortOrder'
          @update:mdSortOrder='$emit("update:currentSortOrder", $event)'
          :md-sort-fn='customSort'
          :md-selected-value.sync='selected'
          @update:mdSelectedValue='$emit("selected-items", $event)'
        >
          <md-table-toolbar v-if='!customHeader'>
            <md-field>
              <label for='pages'>
                {{ $t("commonPhrases.perPage") }}
              </label>
              <md-select v-model='pagination.perPage' name='pages'>
                <md-option
                  v-for='item in pagination.perPageOptions'
                  :key='item'
                  :label='item'
                  :value='item'
                >
                  {{ item }}
                </md-option>
              </md-select>
            </md-field>

            <md-field>
              <md-input
                class="mb-3"
                type='search'
                clearable
                style='width: 200px;'
                :placeholder='$t("commonWords.search") + "..."'
                :value='search'
                @input='updateSearch'
              />
            </md-field>
          </md-table-toolbar>

          <template v-else>
            <slot name='custom-header' :pagination='pagination'/>
          </template>

          <md-table-toolbar
            v-if='selectable'
            slot='md-table-alternate-header'
            slot-scope='{ count }'
            style='position: relative;'
          >
            <div class="backgroundRed md-toolbar">
              <div class="md-toolbar-section-start">
                {{ count }}
                {{ count > 1 ? $t("commonWords.itemsSelected") : $t("commonWords.itemSelected") }}
              </div>

              <div class="md-toolbar-section-end" v-if='selectable'>
                <div v-if='!allowDeleteSelected'>
                  <slot name='deleteSelectedMessage'/>
                </div>

                <md-button
                  class="md-simple.md-github"
                  :disabled='isReadOnly || !allowDeleteSelected'
                  @click='$emit("delete-selected", selected)'
                >
                  <md-icon>delete</md-icon>
                    {{ $t("commonWords.delete") }}
                </md-button>

                <md-button
                  class="md-simple md-github"
                  @click='clearSelection'
                >
                  {{ $t("commonWords.cancel") }}
                </md-button>
              </div>
            </div>
          </md-table-toolbar>

          <md-table-row
            slot='md-table-row'
            slot-scope='props'
            :md-selectable='selectable ? "multiple" : undefined'
            @click='$emit("click-row", props)'
            style='cursor: pointer;'
            :class='rowClasses(props.item)'
          >
            <slot name='cells' v-bind='props'/>
          </md-table-row>
        </md-table>
      </md-card-content>

      <md-card-actions md-alignment='space-between'>
        <div>
          <p class="card-category">
            {{ $t("commonWords.showingItems", { from: from + 1, to: to, total: total }) }}
          </p>
        </div>
        <slot name='footer' :pagination='pagination'/>
        <pagination
          class="pagination-no-border pagination-success"
          v-model='pagination.currentPage'
          @input='$emit("update:currentPage", pagination.currentPage)'
          :per-page='pagination.perPage'
          :total='total'
        />
      </md-card-actions>
    </md-card>
  </div>

  <!-- esse dialog só é mostrado se tiver um carregamento demorado -->
  <!-- (geralmente mais de 1000 itens) -->
  <v-dialog v-model='dialogsGeneration' persistent max-width="400">
    <v-card style='padding: 8px;'>
      <v-card-text style='text-align: center; padding-top: 4px;'>
        <h3>
          {{ slowRequestMessage() }}
        </h3>

        <v-progress-circular
          size='200'
          width='4'
          style='transition: 0.1s'
          color='#9c27b0'
          :value='progress'
          :indeterminate='progress >= 90'
        >
          <b
            v-if='progress !== null'
            style='font-size: 35px;'
          >
            {{ progress + "%" }}
          </b>
        </v-progress-circular>
      </v-card-text>

      <v-card-actions class="mt-2 pb-3 px-4">
        <v-btn
          class="elevation-0"
          :disabled='progress >= 90'
          @click='dialogsGeneration = false'
          text
          color='#FF0000'
        >
          {{$t('table.cancel')}}
        </v-btn>
        <v-spacer/>
      </v-card-actions>
    </v-card>
  </v-dialog>
</div>
</template>

<script>
import Pagination from '@/components/Pagination.vue'
import enumPropValidator from '@/helpers/enumPropValidator'
import isTenantMixin from '@/components/mixins/isTenantMixin'
import debounce from 'lodash.debounce'
import Swal from 'sweetalert2'
import jsPDF from 'jspdf'
import 'jspdf-autotable'
import VueJsonToCsv from 'vue-json-to-csv'
import XLSIcon from '@/assets/img/xls-icon.svg'
import XLSXIcon from '@/assets/img/xlsx-icon.svg'
import * as XLSX from 'xlsx'

export default {
  model: {
    prop: 'data'
  },
  props: {
    data: { type: Array, default: Array },
    title: { required: true, type: String },
    isReadOnly: { default: false, type: Boolean },
    selectable: { type: Boolean, default: true },
    currentSort: { type: String },
    currentSortOrder: {
      type: String,
      default: 'asc',
      ...enumPropValidator('md-sort-order', ['asc', 'desc'])
    },
    customSort: { required: false, type: Function },
    customTotal: { required: true, type: Number },
    customHeader: { type: Boolean, default: false },
    loading: { type: Boolean, default: false },
    rowClasses: { type: Function, default: () => ({}) },
    allowDeleteSelected: { type: Boolean, default: true },
    endpoint: { required: true },
    filter: { required: true },
    labels: { required: true },
    formatLabelFunction: { type: Function, required: true },
    createHeader: { type: Function },
    searchOptionsProps: { type: Array, default: Array },
    searchLabelsProps: { type: Array, default: Array },
    searchProps: { type: String, default: String },
    orientationPDF: { type: String, default: 'portrait' }
  },
  components: {
    XLSXIcon,
    XLSIcon,
    Pagination,
    VueJsonToCsv
  },
  watch: {
    pagination: {
      handler: 'updatePagination',
      deep: true
    },

    loading (value) {
      if (value === false) {
        const vm = this
        setTimeout(() => {
          vm.delayedLoading = value
        }, 500)
      } else {
        this.delayedLoading = value
      }
    }
  },
  mixins: [isTenantMixin],
  computed: {
    to () {
      let highBound = this.from + this.pagination.perPage
      if (this.total < highBound) {
        highBound = this.total
      }
      return highBound
    },

    from () {
      return this.pagination.perPage * (this.pagination.currentPage - 1)
    },

    total () {
      return this.customTotal ?? (this.data?.length || 0)
    },

    progress () {
      return this.toFixed(this.progressGeneration, 1) * 100
    },

    formatedCVSLabels () {
      let csvObjLabels = {}
      // ['Início', 'Duração', 'Fim']
      // { inicio: {title: 'Início'}, ...}
      this.labels.forEach((label) => {
        csvObjLabels[this.strToSlug(label)] = {
          title: label
        }
      })
      return csvObjLabels
    }
  },
  data () {
    return {
      searchOptions: this.searchOptionsProps,
      searchLabels: this.searchLabelsProps,
      search: this.searchProps,
      pagination: [],
      selected: [],
      delayedLoading: false,
      dialogsGeneration: false,
      loadingGeneration: {
        pdf: false,
        csv: false,
        print: false,
        xls: false,
        xlsx: false
      },
      progressGeneration: 0,
      csvData: [],
      csvName: null,
      fileType: 'pdf'
    }
  },
  methods: {
    updateSearch: debounce(function (value) {
      this.search = value
      this.$emit('search-query', value)
    }, 400),

    updateSearchOptions (nV) {
      this.$emit('search-options', nV)
    },

    slowRequestMessage () {
      if (this.fileType === 'pdf') {
        return this.$t('dataTable.generatingPdf')
      } else if (this.fileType === 'xlsx') {
        return this.$t('dataTable.generatingXLSX')
      } else if (this.fileType === 'xls') {
        return this.$t('dataTable.generatingXLS')
      } else if (this.fileType === 'csv') {
        return this.$t('dataTable.generatingCSV')
      }
    },

    /* -----------
      Pagination
    -------------- */
    updatePagination (pagination, oldPagination) {
      this.$emit('pagination', pagination, oldPagination)
    },

    clearSelection () {
      this.selected = []
      this.$emit('clear-selection')
    },

    resetPagination () {
      this.pagination = {
        perPage: 10,
        currentPage: 1,
        perPageOptions: [5, 10, 25, 50]
      }
    },

    /* ----------------
      PDFs e arquivos
    ------------------- */
    async generateFile (type) {
      this.fileType = type
      const totalItems = JSON.parse(JSON.stringify(this.customTotal))
      this.progressGeneration = 0

      if (totalItems > 1000) {
        this.dialogsGeneration = true
      }
      this.loadingGeneration[type] = true

      let filterClone = JSON.parse(JSON.stringify(this.filter))
      const perPage = 1000

      if (filterClone.perPage) {
        filterClone.perPage = perPage
      }
      let dataPages

      try {
        const response = await this.$axios.get(this.endpoint, {
          params: filterClone
        })
        dataPages = [...response.data.data]
        const totalPages = response.data.total / perPage

        this.progressGeneration = 0.1
        const unity = 0.9 / parseInt(totalPages)

        for (let i = 1; i < totalPages; i++) {
          if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('table.canceledByUser'))
          filterClone.page = i
          let subsequentResponse = await this.$axios.get(this.endpoint, {
            params: filterClone
          })
          dataPages = [...dataPages, ...subsequentResponse.data.data]
          this.progressGeneration += unity
        }

        if (type === 'pdf' || type === 'print') {
          let bodyLabels = []
          let labelLine = []

          dataPages.forEach(item => {
            if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('table.canceledByUser'))
            this.labels.forEach((element, index) => {
              labelLine.push(this.formatLabelFunction(item, index))
            })
            let tmp = document.createElement('DIV')
            tmp.innerHTML = labelLine[2] ? labelLine[2] : ''
            labelLine[2] = tmp.textContent || tmp.innerText || ''
            bodyLabels.push(labelLine)
            labelLine = []
          })
          // eslint-disable-next-line
          const doc = new jsPDF({orientation: this.orientationPDF})

          let offSetY = this.createHeader(doc, this.customTotal)

          if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('table.canceledByUser'))
          doc.autoTable({
            startY: offSetY,
            head: [this.labels],
            body: bodyLabels,
            columnStyles: {
              0: { columnWidth: 'auto' },
              1: { columnWidth: 'auto' },
              2: { columnWidth: 'auto' },
              3: { columnWidth: 'auto' },
              4: { columnWidth: 80 }
            }
          })

          // checamos se queremos só o pdf ou também queremos imprimir
          if (type === 'pdf') {
            let timestamp = Date.now()
            doc.save(`${timestamp}_analise_por_servico_entregue.pdf`)
          } else if (type === 'print') {
            window.open(doc.output('bloburl'))
          }
        } else if (type === 'csv') {
          let bodyLabels = []
          let lineObject = {}

          dataPages.forEach(item => {
            if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('table.canceledByUser'))
            this.labels.forEach((element, index) => {
              lineObject[this.strToSlug(element)] = this.formatLabelFunction(item, index)
            })
            let tmp = document.createElement('DIV')
            tmp.innerHTML = lineObject['mensagem'] ? lineObject['mensagem'] : ''
            lineObject['mensagem'] = tmp.textContent || tmp.innerText || ''
            bodyLabels.push(lineObject)
            lineObject = {}
          })

          this.csvData = bodyLabels
          let timestamp = Date.now()
          this.csvName = `${timestamp}_analise_por_servico_entregue`

          this.$nextTick(() => {
            document.querySelector('#csv-component').click()
          })
        } else if (type === 'xlsx' || type === 'xls') {
          let bodyLabels = []
          let lineObject = {}
          dataPages.forEach(item => {
            if (!this.dialogsGeneration && totalItems > 1000) throw new Error(this.$t('table.canceledByUser'))
            this.labels.forEach((element, index) => {
              lineObject[this.strToSlug(element)] = this.formatLabelFunction(item, index)
            })
            bodyLabels.push(lineObject)
            lineObject = {}
          })
          let timestamp = Date.now()
          let fileName = `${timestamp}_analise_por_servico_entregue`
          let wb = XLSX.utils.book_new()
          let ws = XLSX.utils.json_to_sheet(bodyLabels)
          XLSX.utils.book_append_sheet(wb, ws, 'Sheet1')
          if (type === 'xlsx') {
            XLSX.writeFile(wb, `${fileName}.xlsx`)
          } else if (type === 'xls') { XLSX.writeFile(wb, `${fileName}.xls`, { bookType: 'biff8' }) }
        }
      } catch (error) {
        if (error.message === this.$t('table.canceledByUser')) {
          Swal.fire({
            icon: 'error',
            title: this.$t('table.calledOff')
          })
        } else {
          Swal.fire({
            icon: 'error',
            title: this.$t('table.errorGeneratingPdf')
          })
        }
      } finally {
        this.dialogsGeneration = false
        this.loadingGeneration[type] = false

        setTimeout(() => {
          this.progressGeneration = 0
        }, 100)
      }
    },

    toFixed (value, precision) {
      var power = Math.pow(10, precision || 0)
      return Math.round(value * power) / power
    },

    strToSlug (str) {
      str = str.replace(/^\s+|\s+$/g, '') // trim
      str = str.toLowerCase()

      // remove accents, swap ñ for n, etc
      var from = 'ãàáäâẽèéëêìíïîõòóöôùúüûñç·/_,:;'
      var to = 'aaaaaeeeeeiiiiooooouuuunc------'
      for (var i = 0, l = from.length; i < l; i++) {
        str = str.replace(new RegExp(from.charAt(i), 'g'), to.charAt(i))
      }

      str = str.replace(/[^a-z0-9 -]/g, '') // remove invalid chars
        .replace(/\s+/g, '-') // collapse whitespace and replace by -
        .replace(/-+/g, '-') // collapse dashes

      return str
    }
  },
  created () {
    this.resetPagination()
  },
  mounted () {
    this.$nextTick(() => {
      const headers = this.$el.querySelectorAll('th .md-table-head-container .md-table-head-label')

      headers.forEach(el => {
        let title = el.textContent
        el.setAttribute('title', title)
      })
    })
  }
}
</script>

<style lang="css">
  .invisible {
    visibility: hidden !important;
  }
  .md-card .md-card-actions {
    border: 0;
    margin-left: 20px;
    margin-right: 20px;
  }
  .md-checkbox.md-checked .md-checkbox-container:after {
    border-color: #33b231 !important;
    top: 1px !important;
    left: 6px !important;
  }
  .md-table-cell-container {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  .md-table-alternate-header {
    top: 20px !important;
  }
  #chatList > .md-content > table > tbody > .md-table-row > .md-table-cell > .md-table-cell-container {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    text-align: left;
    display: block;
    -webkit-box-pack: none;
    -ms-flex-pack: none;
    justify-content: none;
  }
  #chatList > .md-content > table > thead > tr > .md-table-head > .md-table-head-container > .md-table-head-label {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    width: 100%;
    text-align: left;
  }
  #chatList > .md-content > table > thead > tr > .md-table-head:last-child > .md-table-head-container > .md-table-head-label {
    padding-right: 0px !important;
    /* text-align: right; */
  }
  #chatList > .md-content > table > tbody > .md-table-row > .md-table-cell:hover > .md-table-cell-container {
    text-overflow: clip;
    white-space: normal;
    word-break: break-all;
  }

  .md-tooltip {
    height: 22px !important;
    padding: 8px !important;
    position: absolute !important;
    z-index: 9999 !important;
    pointer-events: none !important;
    border-radius: 2px !important;
    border-top-left-radius: 2px !important;
    border-top-right-radius: 2px !important;
    border-bottom-right-radius: 2px !important;
    border-bottom-left-radius: 2px !important;
    transition: 0.15s cubic-bezier(0, 0, 0.2, 1) !important;
    transition-property: opacity, transform !important;
    will-change: opacity, transform, top, left !important;
    font-size: 10px !important;
    line-height: 22px !important;
    text-transform: none !important;
    white-space: nowrap !important;
    min-width: none !important;
    width: 170px !important;
    max-width: 1000px !important;
    height: auto !important;
    line-height: 20px !important;
    text-align: center !important;
    border-radius: 3px !important;
    background-color: rgba(97, 97, 97, 0.9) !important;
    color: white !important;
    font-size: 14px !important;
    font-weight: 400 !important;
    white-space: normal !important;
    box-shadow: none !important;
  }

  .md-tooltip:after {
    opacity: 0;
  }

  #data-table #header .margin-top {
    margin-top: 15px;
  }

  #data-table #header .margin-left {
    margin-left: 8px;
  }
</style>
